module.exports = __webpack_public_path__ + "static/hero-energy-ind-1435ad4186b18fbcbf66276604865c4b.png";